import { ValidatorsProps, NotificationTemplateTypes } from '@ui/src';
import { PermissionEnum } from '../user-roles/types';

export enum SignatureType {
  NONE = 'NONE',
  SINGLE = 'SINGLE',
}
export interface CreateUserRequest {
  firstName?: string;
  lastName?: string;
  email?: string;
  emailPrivate?: string;
  ipsWhitelist?: string[];
  employeeRoleTemplateId?: string;
  status?: UserStatuses;
  canSignTransactions?: boolean;
  notificationTypeTemplateId?: string;
  signatureType?: string;
}
export type EditUserRequest = CreateUserRequest;

export enum UserStatuses {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export interface UserDetails {
  id: string;
  employeeRoleTemplateId: string;
  profileId: string;
  profile: {
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    avatarImg: string;
  };
  employeePermissions: { permissions: PermissionEnum[] }[];
  status: UserStatuses;
  email: string;
  emailPrivate: string;
  ipsWhitelist: string[];
  employeeRoleTemplateName?: string;
  canSignTransactions: boolean;
  notificationsTypes: NotificationTemplateTypes[];
  notificationTypeTemplateId?: string;
  isCustomNotificationsTypes?: boolean;
  totpEnabled?: boolean;
}

export interface FormValuesContent {
  id?: string;
  avatarImg?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  emailPrivate?: string;
  ipsWhitelist?: string[];
  employeeRoleTemplateId?: string;
  phone?: string;
  docType?: string;
  docNumber?: string;
  description?: string;
  status?: UserStatuses;
  signatureType?: string;
  canSignTransactions?: boolean;
  notificationTypeTemplateId?: string;
  notificationsTypes?: NotificationTemplateTypes[];
  isCustomNotificationsTypes?: boolean;
  totpEnabled?: boolean;
}

export interface ChangeLog {
  id: string;
  action: { name: string; valueFrom?: string; valueTo?: string };
  date: string;
  userName: string;
}

export interface UserPermissions {
  id: string;
  userId: string;
  permissions: PermissionEnum[];
  defaultPermissions: PermissionEnum[];
}

export interface EditPermissionsRequest {
  permissions: PermissionEnum[];
}

export interface UserValidator {
  createEmployeeSchema: ValidatorsProps;
  updateEmployeeSchema: ValidatorsProps;
}

export interface ColumnWithConfirmTypes {
  children: React.JSX.Element[];
  onSubmit: () => void;
  onCancel: () => void;
  globalError?: string;
  editIsLoading?: boolean;
}

export interface UserLockFormTypes {
  formPanelVisible: boolean;
  lockId?: string;
  onCloseLockPanel: () => void;
  onBlockUserClick: () => void;
}

export interface PermissionColumnsTypes {
  isLoading: boolean;
  error?: string;
}

export interface UserLocksTypes {
  onBlockUserClick: () => void;
  setLockId: (data: string) => void;
  panelIsOpen?: boolean;
}

export interface UserLogs {
  panelIsOpen?: boolean;
}
